import React, { useState, useEffect } from 'react';
import { Building } from 'lucide-react';
import api from '../utils/Api';

const CompanyLogo = ({ company, className = "", fallbackSize = "w-8 h-8", hideImage = false }) => {
    const [logoUrl, setLogoUrl] = useState(null);

    useEffect(() => {
        let objectUrl = null;

        const fetchImage = async () => {
            if (!company?.profile_picture || hideImage) {
                setLogoUrl(null);
                return;
            }

            if (company.profile_picture.startsWith('http')) {
                setLogoUrl(company.profile_picture);
                return;
            }

            try {
                const pathParts = company.profile_picture.split('/');
                const filename = pathParts.pop();
                const folder = pathParts.length > 0 ? pathParts.join('/') : 'profile_pictures';

                const response = await api.get(`/files/${folder}/${filename}`, {
                    responseType: 'blob',
                });

                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                objectUrl = window.URL.createObjectURL(blob);
                setLogoUrl(objectUrl);
            } catch (err) {
                console.error("Error fetching company logo:", err);
                setLogoUrl(null);
            }
        };

        fetchImage();

        return () => {
            if (objectUrl) {
                window.URL.revokeObjectURL(objectUrl);
            }
        };
    }, [company?.profile_picture, hideImage]);

    if (logoUrl && !hideImage) {
        return (
            <img
                src={logoUrl}
                alt={company?.company_name || "Company Logo"}
                className={`${className} object-cover`}
            />
        );
    }

    return (
        <div className={`${className} flex items-center justify-center bg-gray-100 dark:bg-gray-700`}>
            <Building className={`${fallbackSize} text-gray-400 dark:text-gray-500`} />
        </div>
    );
};

export default CompanyLogo;
